import './index.scss';
import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BookGymInfo from '../../pages/book-fitness/BookGymInfo';
import BookGymForm from '../../pages/book-fitness/BookGymForm';
import PaymentIframe from '../../shared/PaymentIframe/Paymentiframe';
import { useMyGymRoom } from '../../../store/gym-management/GymHooks';
import BookingSelectCreditCard from '../../shared/BookingSelectCreditCard';
import BookSuccessMessage from '../../pages/book-fitness/BookSuccessMessage';
import { useSetUnmountModalCallback } from '../../../store/modal/modalHooks';
import PaymentManagementApi from '../../../API/payment/PaymentManagement.api';
import CancellationPolicyInfo from '../../shared/cancellation-policy/CancellationPolicy';
import BookContainer from '../../shared/book-components/BookModalComponent/BookModalComponent';

const BookGymModal = () => {
  const gym = useMyGymRoom();
  const { t } = useTranslation();
  const currentDate = new Date();
  const setUnmountModalCallBack = useSetUnmountModalCallback();

  const [orderId, setOrderId] = useState(0);
  const [showCreditsCardPageAction, setShowCreditsCardPageAction] =
    useState<any>();
  const [paymentPageUrl, setPaymentPageUrl] = useState('');
  const [showSuccessPage, setShowSuccessPage] = useState(false);
  const [showCancellationPolicy, setShowCancellationPolicy] = useState(false);

  const defaultValues = {
    date: currentDate,
    start: '',
    end: '',
  };

  if (!gym) {
    return <div></div>;
  }

  useEffect(() => {
    if (orderId) {
      setUnmountModalCallBack(() => {
        PaymentManagementApi.cancelPaymentProcess({
          order_id: orderId.toString(),
        }).finally();
      });
    }
  }, [orderId]);

  const form = useForm({ defaultValues });
  const {
    formState: { errors },
  } = form;

  return (
    <div className="book-gym-modal">
      <BookContainer
        infoComponent={
          !showCancellationPolicy ? (
            <BookGymInfo gym={gym} form={form} />
          ) : (
            <CancellationPolicyInfo policyId={gym.policyId} />
          )
        }
        formComponent={
          showSuccessPage ? (
            <BookSuccessMessage />
          ) : paymentPageUrl ? (
            <div className="book-gym-modal-iframe">
              <PaymentIframe
                url={paymentPageUrl}
                backText={t('BACK_BUTTON_TEXT')}
                onClickBack={() => {
                  setPaymentPageUrl('');
                  setShowCreditsCardPageAction(undefined);
                  if (orderId) {
                    PaymentManagementApi.cancelPaymentProcess({
                      order_id: orderId.toString(),
                    }).finally();
                  }
                }}
                onPaymentSuccess={() => setShowSuccessPage(true)}
              />
            </div>
          ) : showCreditsCardPageAction ? (
            <BookingSelectCreditCard
              onClickSelectCreditCard={() => showCreditsCardPageAction()}
              onClickSelectNewCreditCard={() => showCreditsCardPageAction()}
              onClickBack={() => setShowCreditsCardPageAction(undefined)}
            />
          ) : (
            <BookGymForm
              form={form}
              gym={gym}
              setOrderId={setOrderId}
              setShowSuccessPage={setShowSuccessPage}
              setShowPaymentPage={setPaymentPageUrl}
              setShowCreditsCardPage={(callBack) => {
                setShowCreditsCardPageAction(() => callBack);
              }}
              setShowCancellationPolicy={setShowCancellationPolicy}
              showCancellationPolicy={showCancellationPolicy}
            />
          )
        }
      />
    </div>
  );
};

export default BookGymModal;
